<template>
  <div class="dispatchorders">
    <h1 class="subheading grey--text">Orders awaiting dispatch</h1>
    <h2 class="subheading font-weight-thin grey--text">
      {{ getOrderCount() }} waiting
      <v-btn
        icon
        class="font-weight-thin grey--text"
        @click="getOrdersForDispatch"
        ><v-icon>refresh</v-icon></v-btn
      >
    </h2>

    <v-container class="my-5">
      <v-expansion-panels>
        <v-expansion-panel
          v-for="order in ordersAwaitingDispatch"
          :key="order.cartId"
        >
          <v-expansion-panel-header
            v-on:click="setCartId(order.cartId)"
            class="py-1"
          >
            <v-row class="py-0">
              <v-col cols="6"> {{ order.cartId }} </v-col>
              <v-col cols="6">
                <div v-if="order.email" class="font-weight-bold">
                  Email: {{ order.email }}
                  <span class="caption"
                    ><v-icon
                      size="15"
                      v-on:click.stop="copyEmailToClipboard(order.email)"
                      >content_copy</v-icon
                    ></span
                  >
                </div>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="px-4 grey--text">
            <v-card class="px-4 grey--text">
              <v-card-text class="packed">
                <v-row>
                  <v-col cols="6 packed">
                    <div>Order Date: {{ order.orderDate }}</div>
                  </v-col>
                  <v-col cols="6 packed">
                    <div>Confirm Date: {{ order.confirmDate }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6 packed">
                    <div>Cart Net Value: {{ order.netCost.price }}</div>
                  </v-col>
                  <v-col cols="6 packed">
                    <div>Cart Total Value: {{ order.totalCost.price }}</div>
                  </v-col>
                  <v-col cols="12 packed">
                    <div v-if="order.notes" class="font-weight-bold">
                      Notes: {{ order.notes }}
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6 packed">
                    <div v-if="order.resellerRef">
                      Ebay Ref: {{ order.resellerRef }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12 packed">
                    <div>
                      Address: {{ order.customerAddress }}
                      <span class="caption"
                        ><v-icon
                          size="15"
                          @click="copyAddressToClipboard(order.customerAddress)"
                          >content_copy</v-icon
                        ></span
                      >
                    </div>
                  </v-col>
                </v-row>
                <div
                  v-for="cartitem in cartContents.cart"
                  :key="cartitem.id"
                  class="px-6 my-3"
                >
                  <v-row>
                      {{ cartitem.item }} - {{ cartitem.description }} ({{
                        cartitem.price
                      }})
                  </v-row>
                </div>
                <v-row>
                <DispatchOrderDialog
                  v-bind:cartId="cartId"
                  v-bind:cartIsTracked="cartIsTracked"
                  @orderDispatched="getOrdersForDispatch"
                />
                <OrderAddressDialog v-bind:cartId="cartId" />
                <GetInvitationDialog
                  v-bind:cartId="cartId"
                  v-bind:button="true"
                  v-bind:icon="false"
                />
                <PendingPaymentDialog v-bind:cartId="cartId" />
                <v-btn
                  absolute
                  right
                  class="primary"
                  @click="copyCartIdToClipboard"
                >
                  <v-icon>add_circle_outline</v-icon>
                </v-btn>
                </v-row>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel></v-expansion-panels
      >
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";
import DispatchOrderDialog from "../components/DispatchOrderDialog";
import OrderAddressDialog from "../components/OrderAddressDialog";
import GetInvitationDialog from "../components/GetInvitationDialog";
import PendingPaymentDialog from "../components/PendingPaymentDialog";
import { store } from "../store.js";

export default {
  components: {
    DispatchOrderDialog,
    OrderAddressDialog,
    GetInvitationDialog,
    PendingPaymentDialog,
  },
  data() {
    return {
      ordersAwaitingDispatch: [],
      cartId: "",
      cartContents: [],
      cartIsTracked: false,
    };
  },
  created() {
    this.getOrdersForDispatch();
  },

  methods: {
    async getOrdersForDispatch() {
      this.ordersAwaitingDispatch = await cartApi.getOrdersDispatch();
    },
    async setCartId(cartId) {
      this.cartContents = [];
      this.cartId = cartId;
      this.cartContents = await cartApi.getCart(cartId);
      let tracked = false;
      if (this.cartContents.cart) {
        this.cartContents.cart.forEach((cartItem) => {
          if (cartItem.item === "tracked_shipping") {
            tracked = true;
          }
        });
      }
      this.cartIsTracked = tracked;
    },
    getOrderCount() {
      return this.ordersAwaitingDispatch.length;
    },
    async copyCartIdToClipboard() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartId).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied cartId " + this.cartId);
      store.storeCartId(this.cartId);
    },
    async copyEmailToClipboard(email) {
      let copyRes = false;
      await navigator.clipboard.writeText(email).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied email " + email);
    },
    async copyAddressToClipboard(address) {
      let copyRes = false;
      await navigator.clipboard.writeText(address).then(
        function () {
          copyRes = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
      if (copyRes) this.$toast("Copied address");
    },
  },
};
</script>

<style>
.packed {
/*  color: red; */
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>